// extracted by mini-css-extract-plugin
export default {"loader":"SmallLoader_loader__3jfvf"};